import React from 'react';
import {Route, Switch} from 'react-router-dom';

import Intro from '../components/intro';

import {ROUTES} from '../config';
import Details from '../containers/details';
import Filters from '../containers/filters';
import List from '../containers/list';

const Content = () => (
	<Switch>
		<Route
			path={ROUTES.DETAILS.path}
			render={({match}) => {
				return (
					<div className="bsknacht17-content">
						<Filters />
						<Details id={parseInt(match.params.featureId)} />
					</div>
				);
			}}
		/>
		<Route path={ROUTES.LIST.path}>
			<div className="bsknacht17-content">
				<Filters />
				<List />
			</div>
		</Route>
		<Route path={ROUTES.INTRO.path}>
			<div className="bsknacht17-content">
				<Intro />
			</div>
		</Route>
	</Switch>
);

export default Content;
